import { useState, useEffect } from 'react';
import api from '../../../services/api';
import DataTable from '../componentes/DataTable';
import DeleteConfirm from '../componentes/DeleteConfirm';

const UbicacionesPanel = () => {
  const [ubicaciones, setUbicaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selected, setSelected] = useState(null);
  const [showDelete, setShowDelete] = useState(false);

  const fetchUbicaciones = async () => {
    try {
      setLoading(true);
      const res = await api.get('/ubicaciones');
      setUbicaciones(res.data?.data || res.data || []);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchUbicaciones(); }, []);

  const handleDelete = (id) => {
    setSelected(ubicaciones.find(u => u.id === id));
    setShowDelete(true);
  };

  const confirmDelete = async () => {
    await api.delete(`/ubicaciones/${selected.id}`);
    setShowDelete(false);
    fetchUbicaciones();
  };

  const columns = [
    { key: 'id', label: 'ID' },
    { key: 'id_mascota', label: 'Mascota ID' },
    { key: 'ubicacion', label: 'Coordenadas' },
    { key: 'fecha_hora', label: 'Fecha/Hora' },
    { key: 'lugar', label: 'Dirección' },
  ];

  return (
    <div>
      <h1 style={{ fontSize: '1.5rem', fontWeight: 800, marginBottom: '1.25rem' }}>Historial de ubicaciones</h1>
      <DataTable
        columns={columns}
        data={ubicaciones}
        loading={loading}
        error={error}
        onEdit={null} // Sin edición (se podría agregar para corregir lugar)
        onDelete={handleDelete}
      />
      {showDelete && (
        <DeleteConfirm
          message={`¿Eliminar la ubicación #${selected.id}?`}
          onConfirm={confirmDelete}
          onCancel={() => setShowDelete(false)}
        />
      )}
    </div>
  );
};

export default UbicacionesPanel;